import {sx} from './sx'
import {useTranslation} from "react-i18next";
import {useAppContext} from "@context/appContext/hooks/useAppContext";
import {Box, Stack, Typography} from "@mui/material";
import MenuBarCustom from "@ui/menuBarCustom/MenuBarCustom";
import {logOut} from "@containers/auth/helpers/helpers";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import {IS_SEPARATED} from "@constants/config";
import {useAccountStyle} from "@containers/accountStyle/hooks/useAccountStyle";

const UserBar = () => {

    const {user, settings} = useAppContext()
    const {tokens} = useAccountStyle()
    const {t} = useTranslation()

    const items = [
        {
            component: <Typography
                onClick={logOut}
            >
                {t('logOut')}
            </Typography>,
            closeMenu: true,
        },
    ]

    if(!IS_SEPARATED){
        items.unshift({
            component: <Typography
                component={'a'}
                href={`${settings?.homeUrl}/iTrack/account/info`}
            >
                {t('accountInfo')}
            </Typography>,
            closeMenu: true,
        })
    }

    return (
        <Stack
            gap={'3px'}
            justifyContent={'center'}
            alignItems={'center'}
            sx={{padding:'3px 0'}}
        >
            <MenuBarCustom
                sx={sx.menuBar}
                items={items}
                button={user?.image ? <Box
                        sx={sx.image}
                        component={'img'}
                        src={user?.image}
                    />
                    : <AccountCircleOutlinedIcon sx={{color: tokens.text}}/>
                }
            />

            {user?.name &&
                <Typography
                    sx={{...sx.name, color: tokens.text}}
                    variant={'caption'}
                >
                    {user?.name}
                </Typography>}
        </Stack>
    );
};

export default UserBar;
